module.exports = __webpack_public_path__ + "img/long-light-colored-transparent.fc7f06b.svg";